import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithBackground.js";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";
import { FiShield, FiZap, FiGlobe, FiUsers, FiTarget, FiBookOpen } from "react-icons/fi";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;
const ContentWithPaddingXl = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24 px-4 sm:px-6 lg:px-8`;
const ContentWithVerticalPadding = tw.div`py-20 lg:py-24`;
const Content2Xl = tw.div`max-w-screen-2xl mx-auto`;

const Heading = tw.h1`font-bold text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-gray-900 leading-tight`;
const HeadingRow = tw.div`flex flex-col items-center text-center`;
const Text = tw.div`mt-8 text-base text-gray-600 max-w-3xl mx-auto`;

const JobGrid = tw.div`grid grid-cols-1 md:grid-cols-2 gap-8 mt-12`;
const JobCard = tw.div`bg-white rounded-lg shadow-lg p-8`;
const JobTitle = tw.h3`text-xl font-semibold text-gray-900 mb-2`;
const JobLocation = tw.p`text-primary-500 font-medium mb-4`;
const JobDescription = tw.p`text-gray-600 mb-4`;
const JobRequirements = tw.ul`space-y-2 mb-6`;
const JobRequirement = tw.li`flex items-center text-gray-600`;
const JobButton = tw.button`w-full py-3 bg-primary-500 text-white rounded-lg font-medium tracking-wide text-sm transition duration-300 transform focus:outline-none focus:shadow-outline hover:bg-primary-600 hover:shadow-lg`;

const BenefitsSection = tw.div`mt-16`;
const BenefitsGrid = tw.div`grid grid-cols-1 md:grid-cols-3 gap-8 mt-8`;
const BenefitCard = tw.div`bg-white rounded-lg shadow-lg p-8`;
const BenefitIcon = tw.div`text-primary-500 text-4xl mb-4`;
const BenefitTitle = tw.h3`text-xl font-semibold text-gray-900 mb-2`;
const BenefitDescription = tw.p`text-gray-600`;

export default () => {
  const jobs = [
    {
      title: "Développeur Full Stack",
      location: "Abidjan, Côte d'Ivoire",
      description: "Participez au développement d'une plateforme de gestion des visiteurs innovante, axée sur la sécurité, la traçabilité et l'expérience utilisateur.",
      requirements: [
        "Minimum 3 ans d'expérience",
        "Maîtrise de React et Node.js",
        "Expérience avec les bases de données",
        "Intérêt pour la sécurité et la digitalisation",
        "Esprit d'équipe et autonomie"
      ]
    },
    {
      title: "Chef de Projet Sécurité Digitale",
      location: "Abidjan, Côte d'Ivoire",
      description: "Pilotez des projets visant à améliorer la sécurité et la conformité des solutions de gestion des visiteurs pour nos clients.",
      requirements: [
        "Minimum 5 ans d'expérience",
        "Expérience en gestion de projet IT",
        "Connaissance des normes de sécurité",
        "Capacité à travailler avec des équipes pluridisciplinaires",
        "Sens de l'innovation"
      ]
    }
  ];

  const benefits = [
    {
      icon: <FiShield />,
      title: "Impact Sécurité",
      description: "Contribuez à rendre les entreprises plus sûres et plus accueillantes."
    },
    {
      icon: <FiZap />,
      title: "Innovation Continue",
      description: "Travaillez sur des solutions digitales de pointe pour la gestion des visiteurs."
    },
    {
      icon: <FiGlobe />,
      title: "Portée Internationale",
      description: "Participez à la transformation digitale de l'accueil dans toute l'Afrique."
    },
    {
      icon: <FiUsers />,
      title: "Équipe Passionnée",
      description: "Rejoignez des experts en sécurité, digitalisation et expérience utilisateur."
    },
    {
      icon: <FiTarget />,
      title: "Défis Stimulants",
      description: "Relevez des challenges techniques et humains au quotidien."
    },
    {
      icon: <FiBookOpen />,
      title: "Formation & Croissance",
      description: "Développez vos compétences dans un environnement d'apprentissage continu."
    }
  ];

  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>Carrières chez Tanga</Heading>
          </HeadingRow>
          <Text>
            <p className="text-center mb-8">
              Rejoignez l'équipe qui révolutionne la gestion des visiteurs ! Chez Tanga, nous innovons chaque jour pour offrir plus de sécurité, de rapidité et de simplicité à nos clients et à leurs visiteurs.
            </p>
          </Text>

          <JobGrid>
            {jobs.map((job, index) => (
              <JobCard key={index}>
                <JobTitle>{job.title}</JobTitle>
                <JobLocation>{job.location}</JobLocation>
                <JobDescription>{job.description}</JobDescription>
                <JobRequirements>
                  {job.requirements.map((requirement, requirementIndex) => (
                    <JobRequirement key={requirementIndex}>
                      <span className="mr-2">•</span>
                      {requirement}
                    </JobRequirement>
                  ))}
                </JobRequirements>
                <JobButton>Postuler</JobButton>
              </JobCard>
            ))}
          </JobGrid>

          <BenefitsSection>
            <HeadingRow>
              <Heading>Pourquoi Nous Rejoindre ?</Heading>
            </HeadingRow>
            <Text>
              <p className="text-center mb-8">
                Découvrez les avantages de faire partie de l'équipe Tanga.
              </p>
            </Text>

            <BenefitsGrid>
              {benefits.map((benefit, index) => (
                <BenefitCard key={index}>
                  <BenefitIcon>{benefit.icon}</BenefitIcon>
                  <BenefitTitle>{benefit.title}</BenefitTitle>
                  <BenefitDescription>{benefit.description}</BenefitDescription>
                </BenefitCard>
              ))}
            </BenefitsGrid>
          </BenefitsSection>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
}; 